import { GK, NewsPost, QK, deleteNews, getNews } from 'ck-queries';
import { InformationModal, MainTitle } from 'ck-components';

import { ArchiveTab } from 'ck-features';
import { MutationConfig } from 'ck-global-types';
import toast from 'react-hot-toast';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useTypedNavigate } from 'ck-utils';

const tableStructure = [
  { title: 'TITEL', dataPath: 'displayTitle' },
  { title: 'PUBLICERAD', dataPath: 'createdAtFormatted' },
  { title: 'SENAST UPPDATERAD', dataPath: 'updatedAtFormatted' },
  { title: 'AVSÄNDARE', dataPath: 'committeeName' },
];

export function NewsArchivePage() {
  const [rowData, setRowData] = useState<NewsPost | undefined>();
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const queryClient = useQueryClient();
  const { navigate } = useTypedNavigate();

  const onRowClick = (data: NewsPost) => {
    setRowData(data);
    setIsDetailsOpen(true);
  };

  const onEditClick = ({ id }: NewsPost) => {
    navigate(`/news/edit/${id}`);
  };

  const deleteNewsMutationConfig: MutationConfig = {
    mutationFn: (id: string) =>
      toast.promise(deleteNews(id), {
        loading: 'Laddar...',
        success: 'Nyheten har tagits bort',
        error: 'Kunde inte ta bort inlägg',
      }),
    onSettled: () => {
      queryClient.invalidateQueries(GK.news);
    },
  };

  return (
    <div className='flex flex-1 flex-col'>
      <MainTitle label='Arkiv - Inlägg' customStyle='pb-8' />
      <InformationModal
        modalTitle={rowData?.displayTitle}
        isOpen={isDetailsOpen}
        setIsOpen={setIsDetailsOpen}
      >
        {rowData && (
          <div className='flex max-w-lg flex-col gap-4'>
            <div className='text-sm text-gray-500'>
              {rowData.committeeName} · {rowData.createdAtFormatted}
            </div>
            {rowData.imageUrl && (
              <img
                src={rowData.imageUrl}
                className='h-48 w-full object-cover'
              />
            )}
            <p className='whitespace-pre-wrap'>
              {rowData.bodySwedish || rowData.body}
            </p>
          </div>
        )}
      </InformationModal>
      <ArchiveTab
        emptyStateMessage='Det finns inga inlägg.'
        queryConfig={{
          queryKey: QK.news.all,
          queryFn: getNews,
        }}
        tableStructure={tableStructure}
        mutationConfig={deleteNewsMutationConfig}
        onRowClick={onRowClick}
        onEditClick={onEditClick}
      />
    </div>
  );
}
